



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ContractParagraph } from '@/controllers/types';

/**
 * Пункты договора (CP-S1, этап 1): ручной ввод чипсами. Наружный контракт —
 * value: [{number}] + input (v-model), формат item строго §2 (draft и wire идентичны).
 * Внутри combobox оперирует строками — адаптер здесь. Санитайз: trim, сплит по запятой
 * (D2: запятая = разделитель, покрывает и paste "4.1,4.8"), пустые и дубликаты
 * выбрасываются (D3). Этап 2 заменит внутренности на справочный мультиселект,
 * не меняя контракт компонента.
 */
@Component
export default class ContractParagraphsField extends Vue {
  @Prop({ default: () => [] })
  readonly value!: ContractParagraph[];

  @Prop({ default: () => [] })
  readonly errorMessages!: string[];

  @Prop({ default: 'Пункты договора' })
  readonly label!: string;

  get chipStrings(): string[] {
    return (this.value || []).map((p) => p.number);
  }

  onInput(raw: string[]): void {
    const seen = new Set<string>();
    const numbers: string[] = [];
    (raw || []).forEach((item) => {
      String(item).split(',').forEach((part) => {
        const n = part.trim();
        if (n !== '' && !seen.has(n)) {
          seen.add(n);
          numbers.push(n);
        }
      });
    });
    this.$emit('input', numbers.map((number) => ({ number })));
  }
}
